export default "assets/images/meeting-c25b3b75.svg";